import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { PartyRole } from '../models';

@Injectable()
export class PartyRolesService extends BaseService<PartyRole> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  protected getResourceUrl() {
    return `${this.baseUrl}party-roles`;
  }
}
